export default function TypingIndicator() {
  return (
    <div className="ai-typing" aria-label="Brixi is thinking">
      <span />
      <span />
      <span />
    </div>
  );
}
